// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import {install} from '@icon-park/vue/es/all';
import '@/utils/location.js'
// 全屏滚动 vue-fullpage.js
// import 'fullpage.js/vendors/scrolloverflow';
// import VueFullpage from 'vue-fullpage.js'
// Vue.use(VueFullpage)
// With npm



// install(Vue);
Vue.config.productionTip = false
Vue.use(ElementUI);
import '@/utils/rem.js';
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);
import './assets/css/general.css' // 自定义的常用样式
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
import 'babel-polyfill'


VueAMap.initAMapApiLoader({
  // 高德的key
  key: '239a644334581991e20e4adede02e442',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
});
// import './styles/element-variables.scss'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js